// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../endOfDecade/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var endOfDecadeWithOptions = convertToFP(fn, 2);
export default endOfDecadeWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/endOfDecadeWithOptions/index.js
// module id = 859
// module chunks = 0